var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #b9895d;\r\n      }\r\n\r\n      .st1 {\r\n        fill: none;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #803ac0;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #c5984a;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #985b97;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #94559e;\r\n      }\r\n\r\n      .st6 {\r\n        fill: #d1a935;\r\n      }\r\n\r\n      .st7 {\r\n        fill: #c89d45;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #8e4da8;\r\n      }\r\n\r\n      .st9 {\r\n        fill: #d5ae2e;\r\n      }\r\n\r\n      .st10 {\r\n        fill: #be8f55;\r\n      }\r\n\r\n      .st11 {\r\n        fill: #8743b5;\r\n      }\r\n\r\n      .st12 {\r\n        fill: #d2ac32;\r\n      }\r\n\r\n      .st13 {\r\n        fill: #c2954e;\r\n      }\r\n\r\n      .st14 {\r\n        fill: #a66e80;\r\n      }\r\n\r\n      .st15 {\r\n        fill: #9e638c;\r\n      }\r\n\r\n      .st16 {\r\n        fill: #cba23e;\r\n      }\r\n\r\n      .st17 {\r\n        fill: #752bd3;\r\n      }\r\n\r\n      .st18 {\r\n        fill: #d5b02d;\r\n      }\r\n\r\n      .st19 {\r\n        fill: #8f4fa6;\r\n      }\r\n\r\n      .st20 {\r\n        fill: #a7707c;\r\n      }\r\n\r\n      .st21 {\r\n        fill: #d9b526;\r\n      }\r\n\r\n      .st22 {\r\n        fill: #dab626;\r\n      }\r\n\r\n      .st23 {\r\n        fill: #8946b1;\r\n      }\r\n\r\n      .st24 {\r\n        fill: #cba13f;\r\n      }\r\n\r\n      .st25 {\r\n        fill: #d6b12c;\r\n      }\r\n\r\n      .st26 {\r\n        fill: #762bd2;\r\n      }\r\n\r\n      .st27 {\r\n        fill: #dab625;\r\n      }\r\n\r\n      .st28 {\r\n        fill: #a66e7e;\r\n      }\r\n\r\n      .st29 {\r\n        fill: #752ad4;\r\n      }\r\n\r\n      .st30 {\r\n        fill: #843fba;\r\n      }\r\n\r\n      .st31 {\r\n        fill: #ab7576;\r\n      }\r\n\r\n      .st32 {\r\n        fill: #c99f42;\r\n      }\r\n\r\n      .st33 {\r\n        fill: #cea639;\r\n      }\r\n\r\n      .st34 {\r\n        fill: #c4984a;\r\n      }\r\n\r\n      .st35 {\r\n        fill: #9c618f;\r\n      }\r\n\r\n      .st36 {\r\n        fill: #8c4aac;\r\n      }\r\n\r\n      .st37 {\r\n        fill: #9252a2;\r\n      }\r\n\r\n      .st38 {\r\n        fill: #c89d44;\r\n      }\r\n\r\n      .st39 {\r\n        fill: #dab526;\r\n      }\r\n\r\n      .st40 {\r\n        fill: #a36a83;\r\n      }\r\n\r\n      .st41 {\r\n        fill: #8440b9;\r\n      }\r\n\r\n      .st42 {\r\n        fill: #8e4ca9;\r\n      }\r\n\r\n      .st43 {\r\n        fill: #a56d80;\r\n      }\r\n\r\n      .st44 {\r\n        fill: #a16788;\r\n      }\r\n\r\n      .st45 {\r\n        fill: #d1aa34;\r\n      }\r\n\r\n      .st46 {\r\n        fill: #782fce;\r\n      }\r\n\r\n      .st47 {\r\n        fill: #a36a84;\r\n      }\r\n\r\n      .st48 {\r\n        fill: #8844b3;\r\n      }\r\n\r\n      .st49 {\r\n        fill: #d3ac31;\r\n      }\r\n\r\n      .st50 {\r\n        fill: #a8727a;\r\n      }\r\n\r\n      .st51 {\r\n        fill: #b07c6d;\r\n      }\r\n\r\n      .st52 {\r\n        fill: #ae7971;\r\n      }\r\n\r\n      .st53 {\r\n        fill: #c2944f;\r\n      }\r\n\r\n      .st54 {\r\n        fill: #ad7773;\r\n      }\r\n\r\n      .st55 {\r\n        fill: #8a48af;\r\n      }\r\n\r\n      .st56 {\r\n        fill: #c69b47;\r\n      }\r\n\r\n      .st57 {\r\n        fill: #a16887;\r\n      }\r\n\r\n      .st58 {\r\n        fill: #c4974b;\r\n      }\r\n\r\n      .st59 {\r\n        fill: #9150a4;\r\n      }\r\n\r\n      .st60 {\r\n        fill: #bf9054;\r\n      }\r\n\r\n      .st61 {\r\n        fill: #af7a6f;\r\n      }\r\n\r\n      .st62 {\r\n        fill: #ca9f41;\r\n      }\r\n\r\n      .st63 {\r\n        fill: #caa040;\r\n      }\r\n\r\n      .st64 {\r\n        fill: #9a5e93;\r\n      }\r\n\r\n      .st65 {\r\n        fill: #b88660;\r\n      }\r\n\r\n      .st66 {\r\n        fill: #c69a48;\r\n      }\r\n\r\n      .st67 {\r\n        fill: #c79b46;\r\n      }\r\n\r\n      .st68 {\r\n        fill: #d8b329;\r\n      }\r\n\r\n      .st69 {\r\n        fill: #813cbe;\r\n      }\r\n\r\n      .st70 {\r\n        fill: #c19450;\r\n      }\r\n\r\n      .st71 {\r\n        fill: #b38168;\r\n      }\r\n\r\n      .st72 {\r\n        fill: #762dd1;\r\n      }\r\n\r\n      .st73 {\r\n        fill: #bc8d58;\r\n      }\r\n\r\n      .st74 {\r\n        fill: #cca33d;\r\n      }\r\n\r\n      .st75 {\r\n        fill: #d8b328;\r\n      }\r\n\r\n      .st76 {\r\n        fill: #d5af2d;\r\n      }\r\n\r\n      .st77 {\r\n        fill: #af7b6e;\r\n      }\r\n\r\n      .st78 {\r\n        fill: #bd8e57;\r\n      }\r\n\r\n      .st79 {\r\n        fill: #772dd0;\r\n      }\r\n\r\n      .st80 {\r\n        fill: #c3964d;\r\n      }\r\n\r\n      .st81 {\r\n        fill: #cda43b;\r\n      }\r\n\r\n      .st82 {\r\n        fill: #bf9153;\r\n      }\r\n\r\n      .st83 {\r\n        fill: #d6b12b;\r\n      }\r\n\r\n      .st84 {\r\n        fill: #7e37c4;\r\n      }\r\n\r\n      .st85 {\r\n        fill: #7c34c7;\r\n      }\r\n\r\n      .st86 {\r\n        fill: #d8b428;\r\n      }\r\n\r\n      .st87 {\r\n        fill: #cda33c;\r\n      }\r\n\r\n      .st88 {\r\n        fill: #8b49ad;\r\n      }\r\n\r\n      .st89 {\r\n        clip-path: url(#clippath-1);\r\n      }\r\n\r\n      .st90 {\r\n        fill: #c59a49;\r\n      }\r\n\r\n      .st91 {\r\n        fill: #96599a;\r\n      }\r\n\r\n      .st92 {\r\n        fill: #d0a936;\r\n      }\r\n\r\n      .st93 {\r\n        fill: #c09351;\r\n      }\r\n\r\n      .st94 {\r\n        fill: #d9b527;\r\n      }\r\n\r\n      .st95 {\r\n        fill: #9151a4;\r\n      }\r\n\r\n      .st96 {\r\n        fill: #d2ab33;\r\n      }\r\n\r\n      .st97 {\r\n        fill: #7b33c9;\r\n      }\r\n\r\n      .st98 {\r\n        fill: #8039c1;\r\n      }\r\n\r\n      .st99 {\r\n        fill: #7e38c3;\r\n      }\r\n\r\n      .st100 {\r\n        fill: #7328d6;\r\n      }\r\n\r\n      .st101 {\r\n        fill: #a76f7e;\r\n      }\r\n\r\n      .st102 {\r\n        fill: #9d628e;\r\n      }\r\n\r\n      .st103 {\r\n        fill: #c89e44;\r\n      }\r\n\r\n      .st104 {\r\n        fill: #9253a1;\r\n      }\r\n\r\n      .st105 {\r\n        fill: #b58364;\r\n      }\r\n\r\n      .st106 {\r\n        fill: #b48266;\r\n      }\r\n\r\n      .st107 {\r\n        fill: #772ecf;\r\n      }\r\n\r\n      .st108 {\r\n        fill: #9f648c;\r\n      }\r\n\r\n      .st109 {\r\n        fill: #8a47b0;\r\n      }\r\n\r\n      .st110 {\r\n        fill: #be9055;\r\n      }\r\n\r\n      .st111 {\r\n        fill: #833dbc;\r\n      }\r\n\r\n      .st112 {\r\n        fill: #a76f7d;\r\n      }\r\n\r\n      .st113 {\r\n        fill: #9e638d;\r\n      }\r\n\r\n      .st114 {\r\n        fill: #ad7872;\r\n      }\r\n\r\n      .st115 {\r\n        fill: #b48167;\r\n      }\r\n\r\n      .st116 {\r\n        fill: #9c6091;\r\n      }\r\n\r\n      .st117 {\r\n        fill: #d2ab32;\r\n      }\r\n\r\n      .st118 {\r\n        fill: #7125da;\r\n      }\r\n\r\n      .st119 {\r\n        fill: #9b5f92;\r\n      }\r\n\r\n      .st120 {\r\n        fill: #a26986;\r\n      }\r\n\r\n      .st121 {\r\n        fill: #bd8f56;\r\n      }\r\n\r\n      .st122 {\r\n        fill: #d0a837;\r\n      }\r\n\r\n      .st123 {\r\n        fill: #8b48ae;\r\n      }\r\n\r\n      .st124 {\r\n        fill: #b27e6a;\r\n      }\r\n\r\n      .st125 {\r\n        fill: #d6b02d;\r\n      }\r\n\r\n      .st126 {\r\n        fill: #cfa639;\r\n      }\r\n\r\n      .st127 {\r\n        fill: #c3974c;\r\n      }\r\n\r\n      .st128 {\r\n        fill: #d3ac32;\r\n      }\r\n\r\n      .st129 {\r\n        fill: #a0658a;\r\n      }\r\n\r\n      .st130 {\r\n        fill: #96589b;\r\n      }\r\n\r\n      .st131 {\r\n        fill: #ac7674;\r\n      }\r\n\r\n      .st132 {\r\n        fill: #9d618f;\r\n      }\r\n\r\n      .st133 {\r\n        fill: #d5af2e;\r\n      }\r\n\r\n      .st134 {\r\n        fill: #95579c;\r\n      }\r\n\r\n      .st135 {\r\n        fill: #8f4ea7;\r\n      }\r\n\r\n      .st136 {\r\n        fill: #8540b8;\r\n      }\r\n\r\n      .st137 {\r\n        fill: #7a31cb;\r\n      }\r\n\r\n      .st138 {\r\n        fill: #8e4ea7;\r\n      }\r\n\r\n      .st139 {\r\n        fill: #a56d81;\r\n      }\r\n\r\n      .st140 {\r\n        fill: #b78661;\r\n      }\r\n\r\n      .st141 {\r\n        fill: #9a5d94;\r\n      }\r\n\r\n      .st142 {\r\n        fill: #b68463;\r\n      }\r\n\r\n      .st143 {\r\n        fill: #bc8c59;\r\n      }\r\n\r\n      .st144 {\r\n        fill: #d0a836;\r\n      }\r\n\r\n      .st145 {\r\n        fill: #7226d9;\r\n      }\r\n\r\n      .st146 {\r\n        fill: #a46c82;\r\n      }\r\n\r\n      .st147 {\r\n        fill: #975999;\r\n      }\r\n\r\n      .st148 {\r\n        fill: #ae7a70;\r\n      }\r\n\r\n      .st149 {\r\n        fill: #aa7477;\r\n      }\r\n\r\n      .st150 {\r\n        fill: #9c6190;\r\n      }\r\n\r\n      .st151 {\r\n        fill: #c99e42;\r\n      }\r\n\r\n      .st152 {\r\n        fill: #d9b427;\r\n      }\r\n\r\n      .st153 {\r\n        fill: #aa7378;\r\n      }\r\n\r\n      .st154 {\r\n        fill: #ab7675;\r\n      }\r\n\r\n      .st155 {\r\n        fill: #bb8c5a;\r\n      }\r\n\r\n      .st156 {\r\n        fill: #b38068;\r\n      }\r\n\r\n      .st157 {\r\n        fill: #b58265;\r\n      }\r\n\r\n      .st158 {\r\n        fill: #a36985;\r\n      }\r\n\r\n      .st159 {\r\n        fill: #cfa738;\r\n      }\r\n\r\n      .st160 {\r\n        fill: #a46b83;\r\n      }\r\n\r\n      .st161 {\r\n        fill: #c79c45;\r\n      }\r\n\r\n      .st162 {\r\n        fill: #d4ae2f;\r\n      }\r\n\r\n      .st163 {\r\n        fill: #995d95;\r\n      }\r\n\r\n      .st164 {\r\n        fill: #8c4bab;\r\n      }\r\n\r\n      .st165 {\r\n        fill: #b8875f;\r\n      }\r\n\r\n      .st166 {\r\n        fill: #ba8a5c;\r\n      }\r\n\r\n      .st167 {\r\n        fill: #9a5e92;\r\n      }\r\n\r\n      .st168 {\r\n        fill: #7227d8;\r\n      }\r\n\r\n      .st169 {\r\n        fill: #d7b22a;\r\n      }\r\n\r\n      .st170 {\r\n        fill: #8642b6;\r\n      }\r\n\r\n      .st171 {\r\n        fill: #d4ad30;\r\n      }\r\n\r\n      .st172 {\r\n        fill: #b68562;\r\n      }\r\n\r\n      .st173 {\r\n        fill: #9f658b;\r\n      }\r\n\r\n      .st174 {\r\n        fill: #c79c46;\r\n      }\r\n\r\n      .st175 {\r\n        fill: #792fcd;\r\n      }\r\n\r\n      .st176 {\r\n        fill: #bb8b5b;\r\n      }\r\n\r\n      .st177 {\r\n        fill: #7e37c3;\r\n      }\r\n\r\n      .st178 {\r\n        fill: #c19350;\r\n      }\r\n\r\n      .st179 {\r\n        fill: #b17d6c;\r\n      }\r\n\r\n      .st180 {\r\n        fill: #d7b12b;\r\n      }\r\n\r\n      .st181 {\r\n        fill: #813bbf;\r\n      }\r\n\r\n      .st182 {\r\n        fill: #7327d7;\r\n      }\r\n\r\n      .st183 {\r\n        fill: #b27f6a;\r\n      }\r\n\r\n      .st184 {\r\n        fill: #995c96;\r\n      }\r\n\r\n      .st185 {\r\n        fill: #8d4caa;\r\n      }\r\n\r\n      .st186 {\r\n        fill: #d6b02c;\r\n      }\r\n\r\n      .st187 {\r\n        fill: #9354a0;\r\n      }\r\n\r\n      .st188 {\r\n        fill: #b27f69;\r\n      }\r\n\r\n      .st189 {\r\n        fill: #c99e43;\r\n      }\r\n\r\n      .st190 {\r\n        fill: #833ebb;\r\n      }\r\n\r\n      .st191 {\r\n        fill: #d2aa33;\r\n      }\r\n\r\n      .st192 {\r\n        fill: #a97279;\r\n      }\r\n\r\n      .st193 {\r\n        fill: #7c34c8;\r\n      }\r\n\r\n      .st194 {\r\n        fill: #a26886;\r\n      }\r\n\r\n      .st195 {\r\n        fill: #95569c;\r\n      }\r\n\r\n      .st196 {\r\n        fill: #823cbd;\r\n      }\r\n\r\n      .st197 {\r\n        fill: #762cd1;\r\n      }\r\n\r\n      .st198 {\r\n        fill: #7429d5;\r\n      }\r\n\r\n      .st199 {\r\n        fill: #8541b7;\r\n      }\r\n\r\n      .st200 {\r\n        fill: #c59949;\r\n      }\r\n\r\n      .st201 {\r\n        fill: #d3ad30;\r\n      }\r\n\r\n      .st202 {\r\n        fill: #985a98;\r\n      }\r\n\r\n      .st203 {\r\n        fill: #8845b2;\r\n      }\r\n\r\n      .st204 {\r\n        fill: #9151a3;\r\n      }\r\n\r\n      .st205 {\r\n        fill: #8744b4;\r\n      }\r\n\r\n      .st206 {\r\n        fill: #7930cc;\r\n      }\r\n\r\n      .st207 {\r\n        fill: #7f38c2;\r\n      }\r\n\r\n      .st208 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .st209 {\r\n        fill: #cea53a;\r\n      }\r\n\r\n      .st210 {\r\n        fill: #9353a0;\r\n      }\r\n\r\n      .st211 {\r\n        fill: #b9885e;\r\n      }\r\n\r\n      .st212 {\r\n        fill: #9050a5;\r\n      }\r\n\r\n      .st213 {\r\n        fill: #7a32ca;\r\n      }\r\n\r\n      .st214 {\r\n        fill: #95569d;\r\n      }\r\n\r\n      .st215 {\r\n        fill: #7d35c6;\r\n      }\r\n\r\n      .st216 {\r\n        fill: #7d36c5;\r\n      }\r\n\r\n      .st217 {\r\n        fill: #93559f;\r\n      }\r\n\r\n      .st218 {\r\n        fill: #c09252;\r\n      }\r\n\r\n      .st219 {\r\n        fill: #bb8b5a;\r\n      }\r\n\r\n      .st220 {\r\n        fill: #a8717b;\r\n      }\r\n\r\n      .st221 {\r\n        fill: #a06689;\r\n      }\r\n\r\n      .st222 {\r\n        fill: #b17e6b;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.81,24.08c23.33,0,46.58,12.43,60.5,29.95,11.11,13.97,15.42,31.56,15.41,45.97-.01,29.55-16.96,55.2-41.54,67.7-15.67,7.97-31.16-27.26-37.09-39.13-1.74,2.67-3.22,5.04-4.43,7.13-1.39,2.39-2.17,4.74-3.83,6.87-.4.52-.93,1.01-1.57,1.48-1.91,1.38-4.33,1.13-6.17-.26l-.27-.22c-.39-.26-.77-.56-1.15-.91-2.86-2.63-.45-14.18.37-17.74.79-3.43,1.72-6.92,2.78-10.45.87-3.68,1.88-7.68,3.02-11.99,1.97-7.42,4.64-15.36,8-23.82.23-.93.52-1.85.87-2.78.23-.81.46-1.62.7-2.43.23-.81.41-1.62.52-2.43-1.28-.23-2.55-.35-3.83-.35h-3.82c-3.83,0-7.71.44-11.65,1.3-3.94.87-7.51,2.26-10.7,4.17-3.19,1.91-5.8,4.38-7.83,7.39-2.03,3.01-3.04,6.61-3.04,10.78,0,4.64,1.45,8.14,4.35,10.52,2.9,2.38,6.72,3.57,11.48,3.57,1.74,0,3.13-.15,4.17-.44,1.04-.29,1.68-.43,1.91-.43.12,0,.23.06.35.17.12.12.23.23.35.35.12.12.17.35.17.69,0,.23-.84.67-2.52,1.3-1.68.64-4.2.96-7.56.96-1.51,0-3.25-.26-5.22-.78-1.97-.52-3.86-1.48-5.65-2.87-1.8-1.39-3.33-3.25-4.61-5.56-1.28-2.32-1.91-5.22-1.91-8.7,0-5.68,1.36-10.49,4.09-14.43,2.72-3.94,6.23-7.13,10.52-9.57,4.29-2.43,9.02-4.2,14.18-5.3,5.16-1.1,10.12-1.65,14.87-1.65s9.25.35,13.83,1.04c4.58.69,9.42,1.04,14.52,1.04s9.19-.32,12.61-.96c3.42-.64,6.26-1.33,8.52-2.09,2.26-.75,3.94-1.45,5.04-2.09,1.1-.64,1.77-.96,2-.96.35,0,.64.35.87,1.04.23.7.46,1.45.7,2.26.23,1.04.4,2.14.52,3.31,0,1.27-.2,2.41-.61,3.39-.4.98-.84,1.77-1.3,2.35-.46.69-1.04,1.33-1.74,1.91-.7.46-2.55,1.1-5.57,1.91-3.01.81-7.01,1.33-12,1.57-.46,0-.9.03-1.3.09-.4.06-.84.09-1.3.09-9.71,0-17.33-4.76-19.44-1.78-4.44,6.26-2.87,9.82-14.04,35.17-2.14,4.85-3.45,9.83-4.96,14.52-1.05,3.26-1.97,6.31-2.76,9.16,3.03-5.19,6.2-9.78,9.49-13.77,3.83-4.64,7.3-8.43,10.43-11.39,3.13-2.96,5.71-5.16,7.74-6.61,2.03-1.45,3.04-2.17,3.04-2.17,1.9-1.43,6.11,1.12,3.7,3.35-6.04,5.97-11.6,10.56-16.84,17.4,2.26,8.8,17.52,47.66,27.8,42.16,22.15-11.85,37.22-35.21,37.22-62.09,0-38.87-31.51-70.38-70.38-70.38S25.43,61.13,25.43,100s31.51,70.38,70.38,70.38c5.22,0,10.34-.57,15.26-1.66l4.31,4.64c-6.24,1.66-12.8,2.55-19.57,2.55-41.93,0-75.92-33.99-75.92-75.92S53.89,24.08,95.81,24.08Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 215.34,
    y: 126.58,
    width: 264.76,
    height: 1.82
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st208"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st118",
    x: 19.9,
    y: 24.08,
    width: 151.84,
    height: 151.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st118",
    cx: 95.81,
    cy: 100,
    r: 75.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st198",
    cx: 95.81,
    cy: 100,
    r: 75.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st72",
    cx: 95.81,
    cy: 100,
    r: 75.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st206",
    cx: 95.81,
    cy: 100,
    r: 74.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st193",
    cx: 95.81,
    cy: 100,
    r: 74.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st177",
    cx: 95.81,
    cy: 100,
    r: 73.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st181",
    cx: 95.81,
    cy: 100,
    r: 73.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st190",
    cx: 95.81,
    cy: 100,
    r: 72.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st199",
    cx: 95.81,
    cy: 100,
    r: 72.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st48",
    cx: 95.81,
    cy: 100,
    r: 72.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st55",
    cx: 95.81,
    cy: 100,
    r: 71.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st164",
    cx: 95.81,
    cy: 100,
    r: 71.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st138",
    cx: 95.81,
    cy: 100,
    r: 70.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st95",
    cx: 95.81,
    cy: 100,
    r: 70.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st210",
    cx: 95.81,
    cy: 100,
    r: 70.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st195",
    cx: 95.81,
    cy: 100,
    r: 69.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st147",
    cx: 95.81,
    cy: 100,
    r: 69.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st184",
    cx: 95.81,
    cy: 100,
    r: 68.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st167",
    cx: 95.81,
    cy: 100,
    r: 68.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st35",
    cx: 95.81,
    cy: 100,
    r: 67.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 95.81,
    cy: 100,
    r: 67.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st221",
    cx: 95.81,
    cy: 100,
    r: 67.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st194",
    cx: 95.81,
    cy: 100,
    r: 66.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 95.81,
    cy: 100,
    r: 66.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st43",
    cx: 95.81,
    cy: 100,
    r: 65.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 95.81,
    cy: 100,
    r: 65.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st220",
    cx: 95.81,
    cy: 100,
    r: 65.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st153",
    cx: 95.81,
    cy: 100,
    r: 64.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 95.81,
    cy: 100,
    r: 64.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st54",
    cx: 95.81,
    cy: 100,
    r: 63.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st52",
    cx: 95.81,
    cy: 100,
    r: 63.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 95.81,
    cy: 100,
    r: 62.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st179",
    cx: 95.81,
    cy: 100,
    r: 62.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st183",
    cx: 95.81,
    cy: 100,
    r: 62.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st71",
    cx: 95.81,
    cy: 100,
    r: 61.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st157",
    cx: 95.81,
    cy: 100,
    r: 61.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st142",
    cx: 95.81,
    cy: 100,
    r: 60.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st140",
    cx: 95.81,
    cy: 100,
    r: 60.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st165",
    cx: 95.81,
    cy: 100,
    r: 59.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 95.81,
    cy: 100,
    r: 59.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st166",
    cx: 95.81,
    cy: 100,
    r: 59.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st155",
    cx: 95.81,
    cy: 100,
    r: 58.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st73",
    cx: 95.81,
    cy: 100,
    r: 58.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st121",
    cx: 95.81,
    cy: 100,
    r: 57.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st110",
    cx: 95.81,
    cy: 100,
    r: 57.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st82",
    cx: 95.81,
    cy: 100,
    r: 57.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st93",
    cx: 95.81,
    cy: 100,
    r: 56.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st70",
    cx: 95.81,
    cy: 100,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 95.81,
    cy: 100,
    r: 55.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st80",
    cx: 95.81,
    cy: 100,
    r: 55.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st58",
    cx: 95.81,
    cy: 100,
    r: 54.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 95.81,
    cy: 100,
    r: 54.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st90",
    cx: 95.81,
    cy: 100,
    r: 54.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st56",
    cx: 95.81,
    cy: 100,
    r: 53.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st174",
    cx: 95.81,
    cy: 100,
    r: 53.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 95.81,
    cy: 100,
    r: 52.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 95.81,
    cy: 100,
    r: 52.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st151",
    cx: 95.81,
    cy: 100,
    r: 52.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st62",
    cx: 95.81,
    cy: 100,
    r: 51.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st63",
    cx: 95.81,
    cy: 100,
    r: 51.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st24",
    cx: 95.81,
    cy: 100,
    r: 50.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 95.81,
    cy: 100,
    r: 50.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st74",
    cx: 95.81,
    cy: 100,
    r: 49.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st87",
    cx: 95.81,
    cy: 100,
    r: 49.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st81",
    cx: 95.81,
    cy: 100,
    r: 49.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st209",
    cx: 95.81,
    cy: 100,
    r: 48.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st33",
    cx: 95.81,
    cy: 100,
    r: 48.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st126",
    cx: 95.81,
    cy: 100,
    r: 47.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st159",
    cx: 95.81,
    cy: 100,
    r: 47.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st122",
    cx: 95.81,
    cy: 100,
    r: 46.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st144",
    cx: 95.81,
    cy: 100,
    r: 46.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st92",
    cx: 95.81,
    cy: 100,
    r: 46.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 95.81,
    cy: 100,
    r: 45.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st45",
    cx: 95.81,
    cy: 100,
    r: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st191",
    cx: 95.81,
    cy: 100,
    r: 44.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st96",
    cx: 95.81,
    cy: 100,
    r: 44.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st117",
    cx: 95.81,
    cy: 100,
    r: 44.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st128",
    cx: 95.81,
    cy: 100,
    r: 43.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st49",
    cx: 95.81,
    cy: 100,
    r: 43.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st201",
    cx: 95.81,
    cy: 100,
    r: 42.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st171",
    cx: 95.81,
    cy: 100,
    r: 42.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 95.81,
    cy: 100,
    r: 41.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 95.81,
    cy: 100,
    r: 41.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 95.81,
    cy: 100,
    r: 41.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st133",
    cx: 95.81,
    cy: 100,
    r: 40.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st133",
    cx: 95.81,
    cy: 100,
    r: 40.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st76",
    cx: 95.81,
    cy: 100,
    r: 39.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st125",
    cx: 95.81,
    cy: 100,
    r: 39.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st186",
    cx: 95.81,
    cy: 100,
    r: 39.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st186",
    cx: 95.81,
    cy: 100,
    r: 38.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 95.81,
    cy: 100,
    r: 38.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st83",
    cx: 95.81,
    cy: 100,
    r: 37.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st180",
    cx: 95.81,
    cy: 100,
    r: 37.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st180",
    cx: 95.81,
    cy: 100,
    r: 36.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st169",
    cx: 95.81,
    cy: 100,
    r: 36.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st169",
    cx: 95.81,
    cy: 100,
    r: 36.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st169",
    cx: 95.81,
    cy: 100,
    r: 35.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st169",
    cx: 95.81,
    cy: 100,
    r: 35.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st68",
    cx: 95.81,
    cy: 100,
    r: 34.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st68",
    cx: 95.81,
    cy: 100,
    r: 34.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st68",
    cx: 95.81,
    cy: 100,
    r: 33.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st68",
    cx: 95.81,
    cy: 100,
    r: 33.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st75",
    cx: 95.81,
    cy: 100,
    r: 33.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st75",
    cx: 95.81,
    cy: 100,
    r: 32.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st86",
    cx: 95.81,
    cy: 100,
    r: 32.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st86",
    cx: 95.81,
    cy: 100,
    r: 31.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st86",
    cx: 95.81,
    cy: 100,
    r: 31.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st152",
    cx: 95.81,
    cy: 100,
    r: 31.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st152",
    cx: 95.81,
    cy: 100,
    r: 30.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st152",
    cx: 95.81,
    cy: 100,
    r: 30.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st152",
    cx: 95.81,
    cy: 100,
    r: 29.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st94",
    cx: 95.81,
    cy: 100,
    r: 29.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st94",
    cx: 95.81,
    cy: 100,
    r: 28.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st94",
    cx: 95.81,
    cy: 100,
    r: 28.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st94",
    cx: 95.81,
    cy: 100,
    r: 28.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 95.81,
    cy: 100,
    r: 27.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 95.81,
    cy: 100,
    r: 27.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 95.81,
    cy: 100,
    r: 26.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 95.81,
    cy: 100,
    r: 26.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 95.81,
    cy: 100,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 95.81,
    cy: 100,
    r: 25.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 95.81,
    cy: 100,
    r: 25.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st39",
    cx: 95.81,
    cy: 100,
    r: 24.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st39",
    cx: 95.81,
    cy: 100,
    r: 24.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st39",
    cx: 95.81,
    cy: 100,
    r: 23.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st39",
    cx: 95.81,
    cy: 100,
    r: 23.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 95.81,
    cy: 100,
    r: 23.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 95.81,
    cy: 100,
    r: 22.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 22.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 21.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 21.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 20.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 20.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 20.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 19.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 19.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 18.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 18.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 18.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 17.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 17.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 16.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 16.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 15.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 15.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 15.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 14.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 14.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 13.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 13.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 12.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 12.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 11.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 11.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 10.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 10.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 10.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 9.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 9.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 8.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 8.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 7.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 7.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 6.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 6.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 5.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 5.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 5.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 4.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 4.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 3.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 3.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 1.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 95.81,
    cy: 100,
    r: 0.42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M216.13,112.15c-.54-.25-.79-.54-.79-1.13,0-2.39,2.7-8.2,10.7-21.1,6.03-9.63,16.93-26.2,21.1-32.03,0,0,2.65-3.63,2.65-3.75,0-.08-.28-.14-1.41-.14-2.96,0-7.52.11-19.21.7-5.44.25-6.08.31-6.08.59v.11c0,.11-.08.17-.37.17-1.55,0-3.1-.11-3.63-.65-.28-.28-.45-.56-.45-.79,0-2.45,24.17-2.85,31.38-2.85,7.58,0,23.69.45,26.11.73,1.58.2,2.54.62,2.54,1.13,0,.76-.39.79-12.76.79h-11.32c-1.89,3.01-1.75,2.96-11.77,17.94-13.35,19.97-18.93,29.27-20.42,31.8-.03.06-.06.08-.06.11l.03.03c.06,0,.34-.23.62-.23.31,0,.54.17.54.39,0,.14-.39.82-.9,1.46-2.42,3.41-4.59,6.79-5.94,6.79-.17,0-.37-.03-.54-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M248.81,90.49c-.25-.17-.31-.25-.31-.59,0-1.3.03-1.8,5.75-11.44,6.7-11.27,16.59-28.25,20.39-33.72.96-1.3,1.32-1.72,2.42-1.72.51,0,2.11.39,2.11,1.46,0,.99-2.06,4.56-9.69,16.7-2.34,3.72-9.44,15.15-9.92,15.97v.06c.08,0,.51-.31,1.72-1.24,3.1-2.39,6.93-4.2,8.84-4.2,2.14,0,3.04,1.8,3.04,3.46,0,1.07-.23,1.97-2.03,7.13-.62,1.83-.96,3.49-.96,4.53,0,1.24.76,2.14,1.86,2.14.84,0,2.11-.37,3.21-.9,3.41-1.69,8.34-6.96,9.01-6.96.08,0,.11.08.11.2,0,.25-4.08,4.25-5.61,5.49-2.59,2.11-5.1,3.24-7.16,3.24-2.79,0-4.93-2.17-4.93-6.03s2.51-9.63,2.51-10.28c0-.2-.06-.23-.25-.23-1.8,0-5.86,2.11-10.06,5.75-1.16,1.01-1.55,1.52-3.24,4.03-3.94,6.03-5.32,7.27-6.37,7.27-.17,0-.34-.03-.48-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M285.66,90.35c-1.41-.45-2.48-1.38-3.13-2.73-.37-.73-.39-.99-.39-2.56,0-5.35,4.48-10.73,6.53-10.73.87,0,1.72.48,1.72,1.15,0,.45-.23.9-1.44,2.73-2.62,4-3.38,6.56-3.38,8.62,0,1.46.62,2.42,2.53,2.42,4.68,0,12.03-8.37,12.87-8.37.11,0,.17.11.17.28,0,.25-4.25,4.42-5.75,5.63-3.18,2.59-5.72,3.83-7.94,3.83-.62,0-1.21-.08-1.8-.28ZM290.87,71.64c-.23-.17-.37-.42-.37-.73,0-1.35,2.2-4,3.46-4,.7,0,1.52.45,1.52,1.13,0,1.04-2.14,3.83-3.55,3.83-.39,0-.87-.11-1.07-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M304.39,90.4c-1.78-.56-2.79-1.94-2.79-3.77,0-2.34,1.52-4.73,5.15-8.14,1.04-.99,1.89-1.89,1.89-1.97,0-.48-2.65.2-2.65-1.97,0-.28.08-.62.22-.99.08-.2,1.63-2.96,3.66-2.96,1.21,0,1.89.59,1.89,1.38,0,1.27-2.45,3.18-2.45,3.27,0,.03.31.06.65.06,1.3.06,2.56.87,2.56,1.94,0,1.01-.99,2.39-3.27,4.73-3.66,3.75-4.62,5.27-4.62,6.31,0,.73.62,1.07,1.92,1.07,2.65,0,6.34-1.55,13.38-6.25,2.68-1.8,2.65-1.8,2.76-1.8.2,0,.37.08.37.2,0,.23-.54.65-2.28,1.89-6.9,4.96-11.58,7.24-14.76,7.24-.59,0-1.13-.08-1.63-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M340.11,90.4c-1.86-.56-4.08-2.25-4.08-6.06v-1.55c-5.32,5.46-7.66,7.46-10.93,7.46-2.79-.03-4.7-2.06-4.7-5.13,0-5.13,5.21-11.6,8.56-11.6,1.15,0,1.69.79,1.69,1.15,0,.14-.56.85-1.27,1.55-3.77,3.94-5.41,8.08-5.41,10.37,0,1.24.2,2.08,1.86,2.08,2,0,4.54-1.69,8.39-5.52,2.06-2.08,2.54-2.62,3.07-3.66,1.41-2.7,2.93-4.11,4.34-4.11.82,0,1.97.62,1.97,1.46,0,.42-.31.99-1.13,2.23-2.51,3.77-2.73,6.14-2.73,7.66,0,1.66.96,2.45,2.25,2.45,2.39,0,5.18-1.35,10.28-5.86,1.58-1.41,2.2-1.89,2.48-1.89,0,0,.2,0,.2.11,0,.28-3.61,3.77-5.69,5.49-2.65,2.23-6,3.58-7.83,3.58-.42,0-.85-.06-1.32-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M332.79,118.94c0-.51.42-1.46,1.35-3.3,5.75-11.38,17.91-32,23.44-39.77,2.03-2.82,2.51-2.93,3.44-2.93s1.61.76,1.61,1.3c0,.65-.85,2.08-3.38,6.11v.03c.08,0,.76-.56,1.66-1.46,4.2-4.06,7.52-5.83,10.14-5.83,3.15,0,4.39,2.37,4.39,4.96,0,1.15-.31,1.89-.62,3.07h2.7c4.7.03,7.13.25,7.13.68,0,.14-.03.17-2.37.17-3.04,0-3.72-.06-7.69-.14l-.99,1.52c-2.73,4.08-8.14,7.61-11.72,7.63-2.25,0-3.83-1.35-3.83-2.96,0-2.14,3.13-5.44,10.56-6.53.96-.14,1.8-.28,1.86-.31.03-.03,1.35-2.34,1.35-4.56,0-1.35-.37-1.92-1.61-1.92-1.44,0-3.72.99-6.06,2.73-1.61,1.18-5.52,5.07-7.32,7.24-6.2,7.38-20.25,35.15-22.84,35.15-.54,0-1.21-.34-1.21-.87ZM369.38,83.02l.51-.76c-1.94.25-3.75.54-5.58,1.27-2.9,1.15-4.76,2.9-4.76,4.31,0,.76.28,1.3,1.52,1.3,2.68,0,6.76-3.97,8.31-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M402.37,90.43c-2.42-.76-4.14-2.62-4.65-4.96-.06-.31-.08-.82-.08-1.38,0-2.08.2-1.92.2-2.25,0-.03,0-.06-.03-.06-.14,0-.7.54-1.75,1.61-3.58,3.61-7.01,6.2-9.94,6.2-3.49,0-4.87-2.59-4.87-5.63,0-4.9,5.1-10.17,10.73-11.24.87-.17,1.72-.25,2.51-.25,3.35,0,4.76,1.04,6.76,3.21,1.61-1.55,2.51-2.45,3.86-2.45.87,0,1.86.68,1.86,1.41,0,.45-.37,1.1-1.63,3.04-2.17,3.35-3.27,6.11-3.27,8.08s1.16,3.21,3.18,3.21c2.84,0,7.04-1.63,12.31-5.8,1.01-.79,1.89-1.46,1.97-1.46s.23.11.34.23l.03.06c0,.56-4.34,4.23-6.96,5.8-3.16,1.92-5.86,2.84-8.39,2.84-.82,0-1.77-.06-2.17-.2ZM395.58,82.29c2.42-2.23,3.1-2.99,4.08-4.51l.65-1.01c-1.63-.76-2.93-1.41-4.62-1.41-4.03,0-8.03,2.9-10.25,7.49-.62,1.3-.65,1.41-.65,2.85v1.49c.56.51.87.87,1.69.87,1.8,0,4.84-1.83,9.1-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M419.93,90.49c-1.32-.56-1.94-1.97-1.94-4.65,0-1.49.22-3.24.68-5.01,1.49-5.97,7.89-17.55,15.97-28.82.03-.03,1.86-2.56,1.86-2.65s-.39-.11-1.44-.11c-2.51,0-17.49.39-17.49.93,0,.17.14.34.14.7,0,.17-.06.25-.17.25s-.31-.11-.56-.34c-.76-.59-2.48-.93-2.48-1.83,0-1.52,9.66-1.58,23.55-1.58q3.38-4.17,6.51-7.44c1.72,0,2.79.23,2.79,1.38,0,.25-.08.56-.25.85-.37.48-3.92,5.15-3.92,5.32.03.03,1.63.11,3.61.2,12.79.54,20.22,1.44,20.22,2.85,0,.25-.28.48-.62.48-.68,0-.39-.56-.9-.65-1.35-.39-16.37-1.16-23.66-1.16-9.18,12.73-17.1,25.75-19.58,32.14-1.21,3.04-1.83,6.68-1.83,7.89,0,.28.03.42.11.42.11,0,.28-.31.62-.31.28,0,.56.25.56.42,0,.28-.73.85-1.15.85-.2,0-.39-.06-.62-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M427.76,90.49c-.25-.17-.31-.25-.31-.59,0-1.3.03-1.8,5.75-11.44,6.7-11.27,16.59-28.25,20.39-33.72.96-1.3,1.32-1.72,2.42-1.72.51,0,2.11.39,2.11,1.46,0,.99-2.06,4.56-9.69,16.7-2.34,3.72-9.44,15.15-9.92,15.97v.06c.08,0,.51-.31,1.72-1.24,3.1-2.39,6.93-4.2,8.84-4.2,2.14,0,3.04,1.8,3.04,3.46,0,1.07-.23,1.97-2.03,7.13-.62,1.83-.96,3.49-.96,4.53,0,1.24.76,2.14,1.86,2.14.84,0,2.11-.37,3.21-.9,3.41-1.69,8.34-6.96,9.01-6.96.08,0,.11.08.11.2,0,.25-4.08,4.25-5.61,5.49-2.59,2.11-5.1,3.24-7.15,3.24-2.79,0-4.93-2.17-4.93-6.03s2.51-9.63,2.51-10.28c0-.2-.06-.23-.25-.23-1.8,0-5.86,2.11-10.06,5.75-1.15,1.01-1.55,1.52-3.24,4.03-3.94,6.03-5.32,7.27-6.37,7.27-.17,0-.34-.03-.48-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M464.61,90.35c-1.41-.45-2.48-1.38-3.13-2.73-.37-.73-.39-.99-.39-2.56,0-5.35,4.48-10.73,6.53-10.73.87,0,1.72.48,1.72,1.15,0,.45-.23.9-1.44,2.73-2.62,4-3.38,6.56-3.38,8.62,0,1.46.62,2.42,2.54,2.42,4.68,0,12.03-8.37,12.87-8.37.11,0,.17.11.17.28,0,.25-4.25,4.42-5.75,5.63-3.18,2.59-5.72,3.83-7.94,3.83-.62,0-1.21-.08-1.8-.28ZM469.82,71.64c-.23-.17-.37-.42-.37-.73,0-1.35,2.2-4,3.46-4,.7,0,1.52.45,1.52,1.13,0,1.04-2.14,3.83-3.55,3.83-.39,0-.87-.11-1.07-.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M215.34,126.58v1.82-1.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st27",
    x: 215.34,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    x: 216.8,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st152",
    x: 218.27,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st86",
    x: 219.73,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st68",
    x: 221.19,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st169",
    x: 222.66,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st180",
    x: 224.12,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st186",
    x: 225.58,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 227.04,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st133",
    x: 228.51,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st162",
    x: 229.97,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st171",
    x: 231.43,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st49",
    x: 232.89,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 234.36,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st96",
    x: 235.82,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st45",
    x: 237.28,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 238.75,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st144",
    x: 240.21,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st122",
    x: 241.67,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st159",
    x: 243.13,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 244.6,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st209",
    x: 246.06,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st81",
    x: 247.52,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st87",
    x: 248.99,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st74",
    x: 250.45,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: 251.91,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 253.37,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st63",
    x: 254.84,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st62",
    x: 256.3,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st32",
    x: 257.76,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st189",
    x: 259.22,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st38",
    x: 260.69,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st161",
    x: 262.15,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st67",
    x: 263.61,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st56",
    x: 265.08,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st66",
    x: 266.54,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st200",
    x: 268,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st34",
    x: 269.46,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st58",
    x: 270.93,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st127",
    x: 272.39,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st80",
    x: 273.85,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 275.31,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st53",
    x: 276.78,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st178",
    x: 278.24,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st93",
    x: 279.7,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st218",
    x: 281.17,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st82",
    x: 282.63,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st60",
    x: 284.09,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 285.55,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st121",
    x: 287.02,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st78",
    x: 288.48,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st73",
    x: 289.94,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st143",
    x: 291.4,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st219",
    x: 292.87,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st176",
    x: 294.33,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st166",
    x: 295.79,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 297.26,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st211",
    x: 298.72,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st165",
    x: 300.18,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st65",
    x: 301.64,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st140",
    x: 303.11,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st172",
    x: 304.57,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st142",
    x: 306.03,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st105",
    x: 307.5,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st157",
    x: 308.96,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st106",
    x: 310.42,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st115",
    x: 311.88,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st156",
    x: 313.35,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st188",
    x: 314.81,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st124",
    x: 316.27,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st222",
    x: 317.73,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st179",
    x: 319.2,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st51",
    x: 320.66,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st77",
    x: 322.12,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st61",
    x: 323.59,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st148",
    x: 325.05,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st52",
    x: 326.51,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st114",
    x: 327.97,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st54",
    x: 329.44,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st131",
    x: 330.9,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st154",
    x: 332.36,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st31",
    x: 333.82,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st149",
    x: 335.29,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st153",
    x: 336.75,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st192",
    x: 338.21,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st50",
    x: 339.68,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st220",
    x: 341.14,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 342.6,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st112",
    x: 344.06,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st28",
    x: 345.53,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    x: 346.99,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st139",
    x: 348.45,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st146",
    x: 349.92,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st160",
    x: 351.38,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st47",
    x: 352.84,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st158",
    x: 354.3,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st120",
    x: 355.77,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st57",
    x: 357.23,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st44",
    x: 358.69,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st221",
    x: 360.15,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st129",
    x: 361.62,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st173",
    x: 363.08,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st108",
    x: 364.54,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st113",
    x: 366.01,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st102",
    x: 367.47,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st132",
    x: 368.93,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st150",
    x: 370.39,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st116",
    x: 371.86,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st119",
    x: 373.32,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st64",
    x: 374.78,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st141",
    x: 376.24,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st163",
    x: 377.71,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st184",
    x: 379.17,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 380.63,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st202",
    x: 382.1,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st147",
    x: 383.56,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st91",
    x: 385.02,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st130",
    x: 386.48,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st134",
    x: 387.95,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st214",
    x: 389.41,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 390.87,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st217",
    x: 392.33,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st187",
    x: 393.8,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st104",
    x: 395.26,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st37",
    x: 396.72,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st204",
    x: 398.19,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st59",
    x: 399.65,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st212",
    x: 401.11,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st19",
    x: 402.57,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st135",
    x: 404.04,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 405.5,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st42",
    x: 406.96,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st185",
    x: 408.43,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st164",
    x: 409.89,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st36",
    x: 411.35,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st88",
    x: 412.81,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st123",
    x: 414.28,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st55",
    x: 415.74,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st109",
    x: 417.2,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st23",
    x: 418.66,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st203",
    x: 420.13,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st48",
    x: 421.59,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st205",
    x: 423.05,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 424.52,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st170",
    x: 425.98,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st199",
    x: 427.44,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st136",
    x: 428.9,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st41",
    x: 430.37,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st30",
    x: 431.83,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st190",
    x: 433.29,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st111",
    x: 434.75,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st196",
    x: 436.22,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st69",
    x: 437.68,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st181",
    x: 439.14,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 440.61,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st98",
    x: 442.07,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st207",
    x: 443.53,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st99",
    x: 444.99,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st84",
    x: 446.46,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st216",
    x: 447.92,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st215",
    x: 449.38,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st85",
    x: 450.84,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st193",
    x: 452.31,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st97",
    x: 453.77,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st213",
    x: 455.23,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st137",
    x: 456.7,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st206",
    x: 458.16,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st175",
    x: 459.62,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st46",
    x: 461.08,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st107",
    x: 462.55,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st79",
    x: 464.01,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st197",
    x: 465.47,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st26",
    x: 466.94,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 468.4,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st29",
    x: 469.86,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st198",
    x: 471.32,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st100",
    x: 472.79,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st182",
    x: 474.25,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st168",
    x: 475.71,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st145",
    x: 477.17,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st118",
    x: 478.64,
    y: 126.58,
    width: 1.46,
    height: 1.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M480.1,128.4v-1.82,1.82Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M222.24,155.3v-12.75h5.12c1.23,0,2.3.27,3.22.81.92.54,1.63,1.29,2.13,2.24.5.95.76,2.06.76,3.33s-.25,2.38-.76,3.33c-.5.96-1.21,1.71-2.12,2.24-.91.54-1.99.8-3.22.8h-5.12ZM227.27,144.74h-2.66v8.38h2.66c1.19,0,2.12-.38,2.79-1.13.67-.75,1-1.77,1-3.06s-.34-2.29-1.01-3.05c-.67-.76-1.6-1.14-2.78-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M248.83,155.49c-.91,0-1.76-.16-2.53-.49-.78-.33-1.46-.79-2.03-1.38-.58-.59-1.02-1.28-1.34-2.09-.32-.8-.47-1.68-.47-2.62s.16-1.82.47-2.62c.32-.8.76-1.5,1.34-2.09.58-.59,1.25-1.05,2.03-1.38.78-.33,1.62-.49,2.53-.49s1.77.16,2.55.49,1.45.79,2.02,1.38c.57.59,1.01,1.29,1.33,2.09.32.8.47,1.67.47,2.61s-.16,1.8-.47,2.61-.76,1.5-1.33,2.1c-.57.59-1.25,1.06-2.02,1.38s-1.63.49-2.55.49ZM248.83,153.23c.77,0,1.45-.19,2.04-.56.6-.38,1.07-.89,1.41-1.54.35-.65.52-1.39.52-2.21s-.17-1.56-.52-2.21c-.35-.65-.82-1.16-1.41-1.54-.6-.38-1.27-.56-2.04-.56s-1.45.18-2.04.56c-.6.37-1.06.88-1.4,1.53-.34.65-.51,1.39-.51,2.23s.17,1.58.51,2.23c.34.65.81,1.16,1.4,1.53.6.37,1.28.56,2.04.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M270.47,155.49c-1.23,0-2.31-.28-3.25-.84-.94-.56-1.68-1.33-2.22-2.32-.54-.99-.81-2.13-.81-3.42,0-.92.16-1.78.49-2.57.33-.79.78-1.48,1.37-2.08s1.26-1.06,2.04-1.38,1.62-.49,2.53-.49,1.79.2,2.63.59c.84.39,1.51.91,2,1.56l-1.51,1.66c-.47-.5-.97-.88-1.48-1.13-.52-.25-1.06-.38-1.63-.38-.75,0-1.43.18-2.03.54-.6.36-1.08.86-1.44,1.49s-.54,1.38-.54,2.21.18,1.61.53,2.25c.35.64.84,1.13,1.48,1.49.63.35,1.36.53,2.19.53.59,0,1.16-.12,1.7-.36s1-.57,1.39-.97l1.17,1.88c-.29.33-.68.62-1.17.89-.49.27-1.03.48-1.62.63-.59.15-1.19.23-1.79.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M289.91,155.41c-1.01,0-1.91-.22-2.7-.65-.79-.43-1.41-1.03-1.87-1.79-.46-.76-.68-1.62-.68-2.58v-7.87h2.39v7.71c0,.56.13,1.06.39,1.51.26.45.61.81,1.04,1.08.43.27.91.4,1.43.4.56,0,1.06-.13,1.51-.4.45-.27.8-.63,1.07-1.08.26-.45.39-.95.39-1.51v-7.71h2.3v7.87c0,.96-.23,1.82-.68,2.58-.46.76-1.08,1.35-1.87,1.79-.79.43-1.7.65-2.71.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M305.74,155.3v-12.75h2.24l3.99,6.5,4.04-6.5h2.13v12.75h-2.35v-4.79c0-.76.02-1.48.05-2.13.03-.66.08-1.29.14-1.89l-3.48,5.36h-1.2l-3.37-5.34c.06.58.1,1.2.13,1.84s.04,1.37.04,2.17v4.79h-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M328.86,155.3v-12.75h8.34v2.15h-5.99v3.02h5.06v2.11h-5.06v3.32h6.07v2.15h-8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M347.54,155.3v-12.75h2.13l6.91,9.29c-.1-.75-.17-1.57-.21-2.46-.04-.89-.06-1.89-.06-3.01v-3.83h2.35v12.75h-2.17l-6.89-9.11c.08.89.15,1.58.18,2.09.04.51.06.92.08,1.22.02.3.03.59.03.86v4.94h-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M371.92,155.3v-10.57h-3.64v-2.19h9.77v2.19h-3.75v10.57h-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M385.33,155.3l4.97-12.75h2.22l4.94,12.75h-2.46l-1.09-2.92h-5.1l-1.11,2.92h-2.37ZM390.43,148.11l-.86,2.22h3.55l-.86-2.28c-.06-.15-.14-.38-.25-.69-.1-.32-.22-.66-.34-1.03-.12-.37-.23-.71-.33-1.01-.15.46-.3.95-.47,1.47s-.32.96-.46,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M408.39,155.3v-10.57h-3.64v-2.19h9.77v2.19h-3.75v10.57h-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M423.75,155.3v-2.1h2.1v-8.56h-2.1v-2.1h6.56v2.1h-2.09v8.56h2.09v2.1h-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M445.85,155.49c-.91,0-1.75-.16-2.53-.49s-1.46-.79-2.03-1.38c-.58-.59-1.02-1.28-1.34-2.09-.32-.8-.47-1.68-.47-2.62s.16-1.82.47-2.62c.32-.8.76-1.5,1.34-2.09.58-.59,1.25-1.05,2.03-1.38s1.62-.49,2.53-.49,1.77.16,2.55.49,1.45.79,2.02,1.38,1.01,1.29,1.33,2.09c.32.8.47,1.67.47,2.61s-.16,1.8-.47,2.61c-.32.8-.76,1.5-1.33,2.1s-1.25,1.06-2.02,1.38-1.63.49-2.55.49ZM445.85,153.23c.77,0,1.45-.19,2.04-.56.59-.38,1.07-.89,1.41-1.54.35-.65.52-1.39.52-2.21s-.17-1.56-.52-2.21c-.35-.65-.82-1.16-1.41-1.54-.6-.38-1.28-.56-2.04-.56s-1.45.18-2.04.56c-.6.37-1.06.88-1.4,1.53s-.51,1.39-.51,2.23.17,1.58.51,2.23.81,1.16,1.4,1.53c.59.37,1.28.56,2.04.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M462.09,155.3v-12.75h2.13l6.91,9.29c-.1-.75-.17-1.57-.21-2.46-.04-.89-.06-1.89-.06-3.01v-3.83h2.35v12.75h-2.17l-6.89-9.11c.08.89.15,1.58.18,2.09.04.51.06.92.08,1.22.02.3.03.59.03.86v4.94h-2.35Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e59652df9b5937f2a83d5c2ae90198d9.svg";
export { ForwardRef as ReactComponent };